import type { APInvoiceExceptionView } from '@erp/rpc';

export function partitionInvoiceExceptions(
  exceptions: readonly APInvoiceExceptionView[],
): {
  open: APInvoiceExceptionView[];
  resolved: APInvoiceExceptionView[];
} {
  return {
    open: exceptions.filter((exception) => exception.status === 'open'),
    resolved: exceptions.filter((exception) => exception.status === 'resolved'),
  };
}
